
export const trackingActions = {
  SET_TRACKING_CODE: 'SET_TRACKING_CODE',
  SET_CUSTOMER_CODE: 'SET_CUSTOMER_CODE',
  SET_REFERAL_CODE: 'SET_REFERAL_CODE',
  SET_UTM_PARAMS: 'SET_UTM_PARAMS',
  SET_FROM_COOKIE:'SET_FROM_COOKIE',
  SET_INITIAL_DATA:'SET_INITIAL_DATA'
};
